import { LemoneroAccountsLogin } from "@lemonero/lemonero-accounts-login/lib/resource/lemonero/accounts-login/src/index";


// @ts-ignore
window[ "$Lemonero" ] = {
	accounts : {
		login : LemoneroAccountsLogin
	}
};
